import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const TRFlag = createIcon({
  displayName: "TRFlag",
  viewBox: "0 0 96 64",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Turkey flag </title>
      <path d="M0 0H96V64H0V0Z" />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="63"
        stroke="black"
        fill="#E20613"
      />
      <path
        d="M50.0728 24.3381L53.5557 29.0927L59.1539 27.2496L55.7082 32.0312L59.191 36.7859L53.5787 34.9865L50.133 39.7681L50.11 33.8744L44.4976 32.075L50.0958 30.2318L50.0728 24.3381Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.6622 22.2178C42.3752 20.2143 39.3794 19 36.1 19C28.9203 19 23.1 24.8203 23.1 32C23.1 39.1797 28.9203 45 36.1 45C39.3794 45 42.3752 43.7857 44.6622 41.7822C41.7359 45.5646 37.1523 48 32 48C23.1634 48 16 40.8366 16 32C16 23.1634 23.1634 16 32 16C37.1523 16 41.7359 18.4354 44.6622 22.2178Z"
        fill="white"
      />
      <path
        d="M0 0V-1H-1V0H0ZM96 0H97V-1H96V0ZM96 64V65H97V64H96ZM0 64H-1V65H0V64ZM0 1H96V-1H0V1ZM95 0V64H97V0H95ZM96 63H0V65H96V63ZM1 64V0H-1V64H1Z"
        fill="#767676"
      />
    </>
  )
});
